if (!customElements.get("customization-form")) {
  customElements.define("customization-form",
    class CustomizationForm extends HTMLElement {
      constructor() {
        super();
        this.globals = window.productGlobals;
        this.variants = this.globals.variants;
        this.productInput = document.querySelector(
          '.product-form input[name="id"]'
        );
        this.template = this.querySelector('template');
        this.formContainer = this.querySelector('[data-form-container]');
      }

      connectedCallback() {
        this.renderForm(null);
        this.setupListener();
      }

      setupListener() {
        this.productInput.addEventListener("change", (evt) => {
          this.renderForm(evt);
        });
      }

      renderForm(evt) {
        let variantId = null;
        if (!evt) {
          variantId = this.productInput.value;
        } else {
          variantId = evt.target.value;
        }

        this.formContainer.innerHTML = "";
        
        const variant = this.variants.find((v) => v.id == variantId);
        if (!variant || !variant.handlingInstructions) return;
        
        const template = this.template.content.cloneNode(true);
        const formCode = variant.handlingInstructions.split('-')[0].trim();
        const form = template.querySelector(`[data-form-template="${formCode}"]`);
        this.formContainer.appendChild(form);
      }
    }
  );
}
